<!--
  - Copyright (c) 2019. K+S France & Isagri Ingénierie
  - Ce composant est la vue qui gère l'affichage des recommandations
  - SD version du 18/09/2019 12:02:08
  -->
<template>
  <div class="form-repport">
    <h1 class="form-title">{{ $t("form_repport_title") }}</h1>
    <p>{{ $t("repport_parcel_resons") }}</p>
    <div v-if="formVisible" id="form">
      <v-checkbox
        v-model="rgpd"
        :label="$t('repport_advise')"
        color="primary"
        @change="emailFocus"
      ></v-checkbox>

      <v-text-field
        id="email"
        v-model="email"
        label="Email"
        type="email"
        clearable
        :error="errTf"
        :error-messages="errMessage"
        prepend-icon="email"
        :disabled="!rgpd"
        :rules="[rules.required]"
      ></v-text-field>

      <div class="tac">
        <v-btn id="btn-send" @click="send" color="primary" :disabled="!rgpd">{{
          $t("repport_sendbtn_label")
        }}</v-btn>
      </div>
    </div>
    <div id="wait" v-if="sended">
      <v-alert type="success" value="true"><div class="tac">{{ $t('repport_sended') }}</div>
      </v-alert>
      <div class="tac">
        <v-btn color="primary" to="/" large>{{ $t("about_btn") }}</v-btn>
      </div>
    </div>
    <div id="err" v-if="sendError">
      <v-alert type="error" value="true">{{ sendErrorMessage }}
      </v-alert>
      <div class="tac">
        <v-btn color="primary" to="/" large>{{ $t("about_btn") }}</v-btn>
      </div>
    </div>

  </div>
  <!-- /.repport -->
</template>

<script>
export default {
  data() {
    return {
      name: "Repport",
      formVisible: true,
      email: "",
      errTf: false,
      errMessage: "",
      etat: null,
      rgpd: false,
      sended: false,
      sendError: false,
      sendErrorMessage: "",
      url: "dfqdsqsd",
      rules: {
        required: value => !!value || this.$i18n.t("err_noemail")
      }
    };
  },
  methods: {
    emailFocus() {
      if (this.rgpd) {
        const emailField = this.$el.querySelector('#email');
        if (emailField) this.$nextTick(() => { emailField.focus() });
      } else {
        // console.log("Decoche");
        this.errTf = false;
        this.errMessage = "";
      }
    },
    checkemail(value) {
      console.log(value);
      value = (value !== null) ? value.trim() : value;
      if (/[^@]+@[^.]+\..*/.test(value)) {
        this.errTf = false;
        this.errMessage = "";
        return true;
      } else {
        this.errTf = true;
        this.errMessage = this.$i18n.t("err_validemail");
        return false;
      }
    },
    send() {
      let valid = this.checkemail(this.email, "Email");
      // console.log(valid);

      if (valid) {
        // this.sended = true;

        this.$store.dispatch("sendRepport", this.email).then(
          m => {
            if (m.flag) {
              this.sended = true;
              this.formVisible = false;
              this.url = m.message;
            } else {
              this.sendError = true;
              this.formVisible = false;

              this.sendErrorMessage = `Une erreur est survenue : ${m.message}`;
            }
          },
          m => {
            console.error("Erreur à l'envois de l'email");
            console.error(m);
          }
        );
      }
      // const emailField = this.$el.querySelector("#email");
      // envois
    }
  }
};
</script>

<style scoped lang="scss">
@import "src/scss/easyfert";

  .repport__header {
    background-color: $c-site1;
  }

 .section {
   display: flex;
   flex-flow: column wrap;

   @media all and (min-width: 30em) {
     flex-flow: row nowrap;
   }
 }

  .col {
    width: 50%;
  }

  .repport__title {
    font-size: 2em;
  }

  .repport_stitle {
    font-size: 1.5em;
  }

  .mentions__legales {
    font-size: 0.75em;
  }
</style>
